// function localWebsocketUrl() {
//   var loc = window.location,
//     newUri;
//   if (loc.protocol === 'https:') {
//     newUri = 'wss:';
//   } else {
//     newUri = 'ws:';
//   }
//   newUri += '//' + loc.host;
//   newUri += '/socket';
//   return newUri;
// }

export default {
  backendUrl: function () {
    // if (process.env.NODE_ENV === 'development') {
    return process.env.VUE_APP_BACKEND_URL;
    // } else {
    //   return '/api/';
    // }
  },
  socketUrl: function () {
    // if (process.env.NODE_ENV === 'development') {
    return process.env.VUE_APP_SOCKET_URL;
    // } else {
    //   return localWebsocketUrl();
    // }
  },
  baseUrl: function () {
    // if (process.env.NODE_ENV === 'development') {
    return '/';
    // } else {
    //   return '/';
    // }
  }
};
